var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"AnnouncementPreview"},[(_vm.infoType == 1 || _vm.infoType == 5)?_c('span',[_vm._v(_vm._s(_vm.info.tiedoteTextList["1"])+" ")]):_vm._e(),(_vm.infoType == 4)?_c('span',[_c('AnnouncementImage',{attrs:{"imageid":_vm.info.tunnus,"showResolution":_vm.showResolution}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }